<template>
  <v-container fluid class="login">
    <v-form ref="form">
      <v-row justify="center" align="center">
        <v-col cols="12" md="6" lg="6">
          <v-container>
            <v-row wrap>
              <v-col cols="12" class="text-center"></v-col>
              <v-col cols="12" class="headline">INICIAR SESIÓN</v-col>
              <v-col cols="12">
                <v-divider></v-divider>
                <br />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="form.email.value"
                  v-bind="form.email.props"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="form.password.value"
                  v-bind="form.password.props"
                  :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                  :type="showPassword ? 'text' : 'password'"
                  @click:append="showPassword = !showPassword"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-btn
                  block
                  color="accent"
                  class="rakken-button black--text"
                  @click.prevent="loginWithPassword"
                  >Ingresar</v-btn
                >
              </v-col>

              <v-col cols="12" class="text-center">
                <v-btn text to="/reset-password"
                  >¿Has olvidado tu contraseña?</v-btn
                >
              </v-col>
            </v-row>
          </v-container>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import User from "@/models/user";
import { app } from "@/config/globals";

export default {
  data() {
    return {
      name: app.name,
      form: User.getLoginForm(),
      showPassword: false
    };
  },
  computed: {
    ...mapState("user", ["loggedIn"])
  },
  watch: {
    // :: If the store gets updated, navigate to home
    loggedIn(newValue) {
      if (newValue) {
        this.$router.push({ name: "nav" });
      }
    }
  },
  methods: {
    ...mapActions("user", ["passwordEmailAction"]),
    async loginWithPassword() {
      if (this.$refs.form.validate()) {
        const data = {
          email: this.form.email.value,
          password: this.form.password.value
        };
        await this.passwordEmailAction(data);
        this.form.email.value = "";
        this.form.password.value = "";
      }
    }
  }
};
</script>

<style>
.v-btn--contained {
  -webkit-box-shadow: unset;
  box-shadow: unset;
}
</style>
